export interface IGetNameParams {
  firstName?: string | null;
  lastName?: string | null;
  authorId: number;
}

const baseName = 'Отчет составил риелтор ID:';

export function getName({ firstName, lastName, authorId }: IGetNameParams) {
  if (firstName && lastName) {
    return `${lastName} ${firstName}`;
  }

  return `${baseName} ${authorId}`;
}
